import NoImage from '@/assets/images/no-image.svg'
import { LazyImage } from '@/modules/shared/components/lazy-image/LazyImage'

interface ImageItemProps {
  src: string | null | undefined
  alt: string
  className?: string
  onClick?: () => void
}

export const ImageItem = ({ src, alt, className, onClick }: ImageItemProps) => (
  <div className={className} onClick={onClick}>
    <LazyImage
      className="size-full"
      src={src || NoImage}
      onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        const target = e.target as HTMLImageElement
        target.onerror = null
        target.src = NoImage
      }}
      alt={alt}
    />
  </div>
)
